module.exports = __webpack_public_path__ + "static/media/magiris-home_01.3709b71c.png";